import React from "react";
import { Unity } from "react-unity-webgl";

const UnityCanvas = ({ unityProvider, cursorStyle, playerOffset }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "var(--app-header-height, 0px)",
        left: `${playerOffset}px`,
        width: `calc(100% - ${playerOffset}px)`,
        height: "calc(100% - var(--app-header-height, 0px))",
      }}
    >
      <Unity
        unityProvider={unityProvider}
        style={{
          width: "100%",
          height: "100%",
          cursor: cursorStyle,
          mt: "50px",
        }}
        devicePixelRatio={window.devicePixelRatio}
        width="100%"
        height="100%"
      />
    </div>
  );
};

export default UnityCanvas;
